import { Button } from "@wise-emotions/react-button";
import { CfStickyElementProps } from "components/StickyElement/CfStickyElement/schema";
import { StickyElement, StickyElementProps } from "components/StickyElement";
import CfAnchor from "components/Anchor";
import React from "react";

export const convertCfStickyElementProps = ({
  ctaAnchor: { dataPosition, ...ctaAnchor },
  description,
  theme,
  ctaLabel,
  ...otherProps
}: CfStickyElementProps) => {
  const isContrast =
    theme === "brand-gradient" || theme === "inverse-base-primary";

  const props: StickyElementProps = {
    ...otherProps,
    description: description || undefined,
    theme: theme ?? undefined,
    isContrast,
    cta: (
      <CfAnchor {...ctaAnchor} dataPosition="sticky">
        <Button
          variant="default"
          size="lg"
          theme={isContrast ? "primary-inverse" : "primary"}
        >
          {ctaLabel}
        </Button>
      </CfAnchor>
    ),
  };

  return props;
};

const CfStickyElement = (props: CfStickyElementProps) => (
  <StickyElement {...convertCfStickyElementProps(props)} />
);

export default CfStickyElement;
